module.exports = __webpack_public_path__ + "static/RachelNormand-f258ab144e8c39c351c9fbd95f3ad80e.jpeg";